module.exports = __webpack_public_path__ + "img/model1_zh.d2bfff96.png";